import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Row.scss';
import { getMergedClassNames } from '../../utils/HTMLUtils';

const rootClassName = styles.rootClassName;

class Row extends Component {
  render() {
    return (
      <div
        className={getMergedClassNames([
          rootClassName,
          typeof this.props.className === 'string' ? this.props.className : '',
          this.props.buttonsRow ? rootClassName + '-buttons-row' : '',
        ])}
      >
        {this.props.children}
      </div>
    );
  }
}

Row.propTypes = {
  className: PropTypes.string,
  buttonsRow: PropTypes.bool,
};

export default Row;
